import React from 'react';
import { motion } from 'framer-motion';
import './SolutionsSection.css';

const SolutionsSection = () => {
  const solutions = [
    {
      id: 1,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3Z" stroke="currentColor" strokeWidth="2"/>
          <path d="M2 8H22" stroke="currentColor" strokeWidth="2"/>
          <circle cx="6" cy="5.5" r="0.5" fill="currentColor"/>
          <circle cx="8" cy="5.5" r="0.5" fill="currentColor"/>
          <circle cx="10" cy="5.5" r="0.5" fill="currentColor"/>
          <path d="M6 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M6 16H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: "Sites Profissionais",
      description: "Sites modernos, responsivos e otimizados para SEO. Perfeitos para apresentar seu negócio online.",
      features: [
        "Design responsivo",
        "Otimização para SEO",
        "Carregamento rápido",
        "Integração com redes sociais"
      ],
      color: "#8b5cf6",
      delay: 0.1
    },
    {
      id: 2,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
          <path d="M8 21L16 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 17L12 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="7" cy="8" r="1" fill="currentColor"/>
          <circle cx="12" cy="8" r="1" fill="currentColor"/>
          <circle cx="17" cy="8" r="1" fill="currentColor"/>
          <path d="M6 12H10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M14 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: "Aplicativos de celular",
      description: "Apps completos para gerenciar horários, clientes e pagamentos. Perfeito para prestadores de serviços.",
      features: [
        "Agenda online",
        "Notificações automáticas",
        "Pagamentos integrados",
        "Relatórios completos"
      ],
      color: "#6366f1",
      delay: 0.2
    },
    {
      id: 3,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="6" y="4" width="12" height="16" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
          <circle cx="9" cy="9" r="1" fill="currentColor"/>
          <circle cx="15" cy="9" r="1" fill="currentColor"/>
          <path d="M9 13H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <rect x="4" y="2" width="2" height="4" rx="1" ry="1" stroke="currentColor" strokeWidth="2"/>
          <rect x="18" y="2" width="2" height="4" rx="1" ry="1" stroke="currentColor" strokeWidth="2"/>
          <path d="M10 16L12 18L14 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="12" cy="21" r="1" fill="currentColor"/>
          <path d="M8 21H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: "Automações",
      description: "Automatize processos repetitivos e ganhe tempo para focar no que realmente importa para seu negócio.",
      features: [
        "WhatsApp Business API",
        "E-mail marketing",
        "Integração de sistemas",
        "Relatórios automáticos"
      ],
      color: "#3b82f6",
      delay: 0.3
    }
  ];

  return (
    <section id="solutions" className="modern-solutions">
      <div className="solutions-container">
        {/* Floating Elements */}
        <div className="floating-elements">
          {Array.from({ length: 15 }, (_, i) => (
            <div
              key={i}
              className="floating-dot"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${4 + Math.random() * 4}s`
              }}
            />
          ))}
        </div>

        {/* Header Section */}
        <motion.div 
          className="solutions-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="solutions-title">
            Nossas
            <span className="title-highlight"> Soluções</span>
            <br />
            para <span className="title-highlight">impulsionar</span> seu negócio
          </h2>
          
          <p className="solutions-subtitle">
            
          </p>
        </motion.div>

        {/* Solutions Grid */}
        <motion.div 
          className="solutions-grid"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          {solutions.map((solution) => (
            <motion.div
              key={solution.id}
              className="solution-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: solution.delay }}
              viewport={{ once: true }}
            >
              <div className="card-content">
                <div 
                  className="solution-icon"
                  style={{ color: solution.color }}
                >
                  {solution.icon}
                </div>
                <h3 className="solution-title">{solution.title}</h3>
                <p className="solution-description">{solution.description}</p>
                
                <ul className="solution-features">
                  {solution.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="solution-feature">
                      <svg 
                        width="16" 
                        height="16" 
                        viewBox="0 0 16 16" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path 
                          d="M13.5 4.5L6 12L2.5 8.5" 
                          stroke="currentColor" 
                          strokeWidth="2" 
                          strokeLinecap="round" 
                          strokeLinejoin="round"
                        />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <button 
                  onClick={() => document.getElementById('form-section').scrollIntoView({ behavior: 'smooth' })}
                  className="solution-button"
                  style={{ borderColor: solution.color }}
                >
                  Quero este projeto
                  <svg 
                    width="16" 
                    height="16" 
                    viewBox="0 0 16 16" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path 
                      d="M3.33334 8H12.6667M12.6667 8L8.66668 4M12.6667 8L8.66668 12" 
                      stroke="currentColor" 
                      strokeWidth="1.33" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default SolutionsSection; 